module.exports = __webpack_public_path__ + "static/media/logomark.6686962d.png";